import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Districts } from '../../model/districts';
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class DistrictsService {
  url = environment.API_URL;
  constructor(private http: HttpClient) { }

  getAll(): Observable<Districts[]>{
    return this.http.get<Districts[]>(`${this.url}districts-info`);
  }
  
  getById(id:number): Observable<Districts>{
    return this.http.get<Districts>(`${this.url}districts-info/${id}`);
  }
}
